import React, { useContext, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Loading from "shared/Loading";
import ErrorPage from "shared/Error";
import { Alert } from "reactstrap";
import { AppContext } from "components/AppContext";
import { ExtractReportContext } from "./ExtractReportContext";
import ReportTable from "./Components/ReportTable";
import axios from "axios";

const Dashboard = () => {
  const {
    error,
    UIAlert,
    setUIAlert,
    loading,
    modalState,
    runReportStatus,
    setRunReportStatus
  } = useContext(ExtractReportContext);
  const { smallNav, StoreAPIDefaults, config } = useContext(AppContext);
  const { id: accountId } = useParams();

  const getAccount = () => {
    axios
      .get(`${config.configApiBaseUrl}/accounts/${accountId}/`, {
        headers: {
          Authorization: `Bearer ${StoreAPIDefaults.accessToken}`
        }
      })
      .then(response => {
        const account = {
          id: response.data?.data[0].accountid,
          name: response.data?.data[0].accountname
        };

        localStorage.setItem("accountDeatils", JSON.stringify(account));
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      setUIAlert(false);
    }, 5000);
  }, [UIAlert, setUIAlert]);
  useEffect(() => {
    if (accountId) {
      getAccount();
    }
  }, [accountId]);

  const createExtractUrl = `/app/account/${accountId}/reports/new`;

  return (
    <div className="page__extractReport">
      {error && <ErrorPage err={error} />}
      {!error && (
        <>
          {loading && <Loading text={typeof loading === "string" && loading} />}
          {runReportStatus === "success" && !modalState.isPaneOpen && (
            <Alert
              style={
                smallNav ? { paddingLeft: "74px" } : { paddingLeft: "280px" }
              }
              color="success"
              toggle={() => setRunReportStatus("")}
            >
              Extract Queued
            </Alert>
          )}
          {runReportStatus === "error" && !modalState.isPaneOpen && (
            <Alert
              style={
                smallNav ? { paddingLeft: "74px" } : { paddingLeft: "280px" }
              }
              color="danger"
              toggle={() => setRunReportStatus("")}
            >
              Extract Failed to Run
            </Alert>
          )}
          {UIAlert && !modalState.isPaneOpen && (
            <Alert
              style={
                smallNav ? { paddingLeft: "74px" } : { paddingLeft: "280px" }
              }
              color="danger"
              toggle={() => setUIAlert(false)}
            >
              {`${UIAlert}`}
            </Alert>
          )}
          <header>
            <h1>All Reports</h1>
            <Link
              to={createExtractUrl}
              className="pillbutton pillbutton--large"
            >
              Create New Report
            </Link>
          </header>
          <hr />
          <div>
            <ReportTable />
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
